export const getAllLists = () => 'products/lists/';
   